import React from 'react'
// components
import RisksRegister from 'components/PageComponents/Risks/Register'
import RisksRegisterBL from 'containers/Risks/RisksRegister/layers'

const RisksRegisterContainer = () => (
  <RisksRegisterBL>
    <RisksRegister />
  </RisksRegisterBL>
)

export default RisksRegisterContainer
